import React from 'react'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input, Spinner } from 'reactstrap'
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import moment from 'moment-timezone'
import { MDBDataTableV5, MDBIcon } from 'mdbreact'
import '@fortawesome/fontawesome-free/css/all.min.css'
import classnames from 'classnames'
import { FaEdit } from 'react-icons/fa'
import { MdDone, MdWarning, MdCancel, MdEmail, MdCameraAlt } from 'react-icons/md'
import { IconContext } from 'react-icons/lib'
import { CSVLink } from 'react-csv'

const headers = [
  {
    label: '*Invoice No.',
    key: 'invoice_no',
  },
  {
    label: '*Customer',
    key: 'customer',
  },
  {
    label: '*Invoice Date',
    key: 'invoice_date',
  },
  {
    label: '*Due Date',
    key: 'due_date',
  },
  {
    label: 'Terms',
    key: 'terms',
  },
  {
    label: 'Location',
    key: 'location',
  },
  {
    label: 'Schedule',
    key: 'schedule',
  },
  {
    label: 'Memo',
    key: 'memo',
  },
  {
    label: 'Item(Product/Service)',
    key: 'item',
  },
  {
    label: 'Item(Description)',
    key: 'item_description',
  },
  {
    label: 'Item(Quantity)',
    key: 'item_quantity',
  },
  {
    label: 'Item(Rate)',
    key: 'item_rate',
  },
  {
    label: '*Item(Amount)',
    key: 'item_amount',
  },
  {
    label: '*Item(TaxCode)',
    key: 'item_taxcode',
  },
  {
    label: 'Item(TaxAmount)',
    key: 'item_taxamount',
  },
  {
    label: 'Currency',
    key: 'currency',
  },
  {
    label: 'Service Date',
    key: 'service_date',
  },
]

const report_headers = [
  {
    label: 'Order ID',
    key: 'order_id',
  },
  {
    label: 'Name',
    key: 'name',
  },
  {
    label: 'Address',
    key: 'address',
  },
  {
    label: 'Country',
    key: 'country',
  },
  {
    label: 'Zip',
    key: 'zip',
  },
  {
    label: 'Phone',
    key: 'phone',
  },
  {
    label: 'Dated Repair',
    key: 'dated_repair',
  },
  {
    label: 'Install Date',
    key: 'install_date',
  },
  {
    label: 'Brand',
    key: 'brand',
  },
  {
    label: 'Model',
    key: 'model',
  },
  {
    label: 'Serial No.',
    key: 'serial_no',
  },
  {
    label: 'Parts',
    key: 'parts',
  },
  {
    label: 'Service Report',
    key: 'service_report',
  },
]

const tbcolumn = [
  {
    label: 'Order ID',
    field: 'order_id',
    sort: 'asc',
  },
  {
    label: 'Invoice',
    field: 'Invoice',
    sort: 'asc',
  },
  {
    label: 'Invoice Date',
    field: 'invoice_dt',
    sort: 'asc',
  },
  {
    label: 'Type',
    field: 'order_type',
    sort: 'asc',
  },
  {
    label: 'Service',
    field: 'service_type',
    sort: 'asc',
  },
  {
    label: 'Price($)',
    field: 'total_price',
    sort: 'asc',
  },
  {
    label: 'Tax($)',
    field: 'total_tax',
    sort: 'asc',
  },
  {
    label: 'Status',
    field: 'order_status',
    sort: 'asc',
  },
  {
    label: 'Payment',
    field: 'payment_status',
    sort: 'asc',
  },
  {
    label: 'Verified',
    field: 'Verified',
    sort: 'asc',
  },
  {
    label: 'Order Date',
    field: 'order_dt',
    sort: 'asc',
  },
  {
    label: 'Action',
    field: 'Action',
    sort: 'asc',
  },
]

class SearchOrder extends React.Component {
  _isMounted = true
  orderDetail = StorageService.getSession('searchOrder')
  comp = StorageService.getSession('selected_org')
  constructor(props) {
    super(props)
    this.state = {
      isLoading: true,
      user_role: this.comp.Role,
      storeRole: this.props.state.storeRole,
      // invoiceDisable:
      //   this.comp.Role === 'Financial' ||
      //   this.comp.Role === 'Admin' ||
      //   this.comp.Role === 'Superuser'
      //     ? false
      //     : true,
      invoiceDisable: this.props.state.storeRole === 'Financial' || this.props.state.storeRole === 'Admin' || this.props.state.storeRole === 'Supervisor' || this.props.state.storeRole === 'Superuser' ? false : true,
      tabList: [{ name: 'Daily' }, { name: 'Search' }],
      status: this.orderDetail && this.orderDetail.status ? this.orderDetail.status : 'Daily',
      stateList: [],
      activeTab: '1',
      orderList: [],
      filterList: [],
      beforeFilterList: [],
      start_dt: this.orderDetail && this.orderDetail.start_dt ? this.orderDetail.start_dt : moment().tz('Asia/Singapore').format('YYYY-MM-DD'),
      end_dt: this.orderDetail && this.orderDetail.end_dt ? this.orderDetail.end_dt : moment().tz('Asia/Singapore').format('YYYY-MM-DD'),
      order_id_str: this.orderDetail && this.orderDetail.order_id_str ? this.orderDetail.order_id_str : '',
      date: this.orderDetail && this.orderDetail.date ? this.orderDetail.date : moment().tz('Asia/Singapore').format('YYYY-MM-DD'),
      fm_date: this.orderDetail && this.orderDetail.fm_date ? this.orderDetail.fm_date : moment().tz('Asia/Singapore').format('YYYY-MM-DD'),
      to_date: this.orderDetail && this.orderDetail.to_date ? this.orderDetail.to_date : moment().tz('Asia/Singapore').format('YYYY-MM-DD'),
      statusList: [],
      filterKey: this.orderDetail && this.orderDetail.filterKey ? this.orderDetail.filterKey : 'Default',
      stateList: [],
      invoiceModal: false,
      edit_order_id: '',
      edit_invoice_dt: '',
      edit_invoice_no: '',
      edit_invoice_verify: '',
      store_id: this.props.match.params.id,
      showInvoice: this.orderDetail && this.orderDetail.showInvoice ? this.orderDetail.showInvoice : false,
      csvList: [],
      csvReport: [],
      onSort: {},
      search_type: 'Order',
    }

    this.csvLinkEl = React.createRef()
    this.csvLinkEl2 = React.createRef()
  }

  componentDidMount() {
    this.getOrderState()
    //this.CsvOrder();
    // this.CsvReport();
    if (this.state.status === 'Daily') {
      this.dailyOrder()
    } else {
      this.searchOrder()
    }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  CsvNotFound() {
    this.setState({ isLoading: false })
    this.notificationSystem.addNotification({
      title: <MdWarning />,
      message: 'Data Not Found',
      level: 'warning',
      position: 'br',
      autoDismiss: 4,
      dismissible: 'click',
    })
  }

  invoiceModal = (order_id, invoice_dt, invoice_no, invoice_verify) => () => {
    let array = [...this.state.filterList]
    if (this.state.onSort.hasOwnProperty('column')) {
      let sortKey = this.state.onSort.column
      if (this.state.onSort.direction === 'asc') {
        array.sort((a, b) => a[sortKey] - b[sortKey])
      } else {
        array.sort((a, b) => b[sortKey] - a[sortKey])
      }
    }
    return this.setState({
      invoiceModal: !this.state.invoiceModal,
      edit_invoice_no: invoice_no,
      edit_order_id: order_id,
      edit_invoice_dt: invoice_dt,
      edit_invoice_verify: invoice_verify,
      filterList: array,
    })
  }

  onSort(value) {
    let array = [...this.state.filterList]
    let sortKey = value.column
    let sortAlphaNum
    if (value.direction === 'asc') {
      sortAlphaNum = (a, b) => a[sortKey].localeCompare(b[sortKey], 'en', { numeric: true })
      array.sort(sortAlphaNum)
    } else {
      sortAlphaNum = (a, b) => b[sortKey].localeCompare(a[sortKey], 'en', { numeric: true })
      array.sort(sortAlphaNum)
    }
    return this.setState({
      filterList: array,
    })
  }

  checkHandler = e => {
    let { name, value } = e.target
    this.setState({
      [name]: !this.state[name],
    })

    if (name === 'showInvoice') {
      let data = this.orderDetail ? this.orderDetail : {}
      data[name] = value
      StorageService.setSession('searchOrder', data)
      this.orderDetail = StorageService.getSession('searchOrder')
      this.filterData(!this.state[name])
    }
  }

  invoice = e => {
    e.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      order_id: this.state.edit_order_id,
      invoice: this.state.edit_invoice_no,
      invoice_dt: this.state.edit_invoice_dt,
      invoice_verify: this.state.edit_invoice_verify ? '1' : '0',
      updated_by: user.email,
    }

    axios
      .post(url + ':3003/v1/order/invoice', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Invoice updated successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ invoiceModal: false })
        this.dailyOrder()
      })
      .catch(error => {
        alert(error)
      })
  }

  getOrderState() {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3003/v1/order/state', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({
            stateList: result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  filterData(showInvoice) {
    let { orderList, filterList, filterKey } = this.state
    if (filterKey !== 'Default') {
      let item = orderList.filter(x => x.order_status === filterKey)
      if (showInvoice) {
        item = item.filter(x => x.invoice_no !== null && x.invoice_no !== '')
      }
      this.setState({ filterList: item })
    } else {
      if (showInvoice) {
        orderList = orderList.filter(x => x.invoice_no !== null && x.invoice_no !== '')
      }
      this.setState({ filterList: orderList })
    }
  }

  changeHandler = e => {
    const { name, value } = e.target
    this.setState({
      [name]: value,
    })
    let data = this.orderDetail ? this.orderDetail : {}
    data[name] = value
    StorageService.setSession('searchOrder', data)
    this.orderDetail = StorageService.getSession('searchOrder')
    if (value === 'Daily') {
      this.dailyOrder()
    } else {
      this.searchOrder()
    }
  }

  filterHandler = e => {
    const { name, value } = e.target
    this.setState({
      [name]: value,
    })
    let data = this.orderDetail ? this.orderDetail : {}
    data[name] = value
    StorageService.setSession('searchOrder', data)
    this.orderDetail = StorageService.getSession('searchOrder')
  }

  inputHandler = e => {
    const { name, value } = e.target
    this.setState({
      [name]: value,
    })
  }

  searchHandler = e => {
    const { name, value } = e.target
    this.setState({
      [name]: value,
    })
    let data = this.orderDetail ? this.orderDetail : {}
    data[name] = value
    StorageService.setSession('searchOrder', data)
    this.orderDetail = StorageService.getSession('searchOrder')

    // if (
    //   name === 'fm_date' ||
    //   name === 'to_date' ||
    //   name === 'start_dt' ||
    //   name === 'end_dt'
    // ) {
    //   this.setState({
    //     isLoading: true,
    //   });
    //   this.CsvOrder(name, value);
    //   if (this.state.status === 'Daily') {
    //     this.CsvReport(name, value);
    //   }
    // }
  }

  dailyOrder = async date => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.props.match.params.id,
      // date: date ? date : this.state.date,
      fm_date: this.state.fm_date,
      to_date: this.state.to_date,
      search_type: this.state.search_type,
    }
    axios
      .post(url + ':3003/v2/order/range', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          for (let i of result.data) {
            if (i.order_dt) {
              i.order_dt = moment(i.order_dt).tz('Asia/Singapore').format('YYYY-MM-DD')
            }
            // if (i.invoice_dt) {
            //   i.invoice_dt = moment(i.invoice_dt)
            //     .tz('Asia/Singapore')
            //     .format('YYYY-MM-DD');
            // }
            if (i.invoice_dt === null) {
              i.invoice_dt = ''
            }

            if (i.invoice_no === null) {
              i.invoice_no = ''
            }

            // i.Invoice = (
            //   <>
            //     {i.invoice_no ? i.invoice_no : ''}
            //     <Button
            //       color="link"
            //       style={{ padding: '2px 0px 5px 5px' }}
            //       onClick={this.invoiceModal(
            //         i.order_id,
            //         i.invoice_dt,
            //         i.invoice_no,
            //         i.invoice_verify,
            //       )}
            //     >
            //       <IconContext.Provider value={{ color: '#2a2c6b' }}>
            //         <FaEdit size={16} />
            //       </IconContext.Provider>
            //     </Button>
            //   </>
            // );

            i.Invoice = i.invoice_no

            // i.Verified = (
            //   <span
            //     className={
            //       'ps-indicator ' + (i.invoice_verify == '1' ? 'on' : 'off')
            //     }
            //   >
            //     {i.invoice_verify == '1' ? 'Yes' : 'No'}
            //   </span>
            // );
            i.Verified = i.invoice_verify == '1' ? 'Yes' : 'No'

            if (i.total_tax) {
              i.total_tax = parseFloat(i.total_tax).toFixed(2)
            }
            i.Action = (
              <div className="ps-action-button">
                <Button className="theme-button theme-button-secondary" onClick={() => this.props.order(i.order_id)}>
                  View
                </Button>
                <Button className="theme-button theme-button-primary" onClick={this.invoiceModal(i.order_id, i.invoice_dt, i.invoice_no, i.invoice_verify)} disabled={this.state.invoiceDisable}>
                  Invoice
                </Button>
              </div>
            )
          }
          this.setState({
            orderList: result.data,
            filterList: result.data,
            isLoading: false,
          })
        }
      })
      .then(() => {
        this.filterData(this.state.showInvoice)
      })
      .catch(error => {
        alert(error)
        this.setState({ isLoading: false })
      })
  }

  searchOrder = async () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.props.match.params.id,
      start_dt: this.state.start_dt,
      end_dt: this.state.end_dt,
      order_id_str: this.state.order_id_str,
    }

    axios
      .post(url + ':3003/v1/order/search', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          for (let i of result.data) {
            if (i.order_dt) {
              i.order_dt = moment(i.order_dt).tz('Asia/Singapore').format('YYYY-MM-DD')
            }
            if (i.total_tax) {
              i.total_tax = parseFloat(i.total_tax).toFixed(2)
            }
            i.Action = (
              <div className="ps-action-button">
                <Button className="theme-button theme-button-secondary" onClick={() => this.props.order(i.order_id)}>
                  View
                </Button>
              </div>
            )
          }
          this.setState({
            orderList: result.data,
            filterList: result.data,
            isLoading: false,
          })
        }
      })
      .catch(error => {
        alert(error)
        this.setState({ isLoading: false })
      })
  }

  CsvOrder = async (name, value) => {
    this.setState({ isLoading: true })
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    let fm_date
    let to_date
    if (this.state.status === 'Daily') {
      fm_date = name === 'fm_date' ? value : this.state.fm_date
      to_date = name === 'to_date' ? value : this.state.to_date
    } else {
      fm_date = name === 'start_dt' ? value : this.state.start_dt
      to_date = name === 'end_dt' ? value : this.state.end_dt
    }
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.props.match.params.id,
      fm_date: fm_date,
      to_date: to_date,
    }

    axios
      .post(url + ':3003/v2/order/export/custom/szw', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          for (let i of result.data) {
            if (i.invoice_date) {
              i.invoice_date = moment(i.invoice_date).tz('Asia/Singapore').format('DD/MM/YYYY')
            }
          }
          if (result.data.length > 0) {
            this.setState(
              {
                csvList: result.data,
                isLoading: false,
              },
              () => {
                setTimeout(() => {
                  this.csvLinkEl.current.link.click()
                })
              },
            )
          } else {
            this.CsvNotFound()
          }
        }
      })
      .catch(error => {
        alert(error)
        this.setState({ isLoading: false })
      })
  }

  CsvReport = async (name, value) => {
    this.setState({ isLoading: true })
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    let fm_date = name === 'fm_date' ? value : this.state.fm_date
    let to_date = name === 'to_date' ? value : this.state.to_date
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.props.match.params.id,
      fm_date: fm_date,
      to_date: to_date,
      search_type: this.state.search_type,
    }

    axios
      .post(url + ':3003/v3/order/export/custom/szwservice', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          for (let i of result.data) {
            if (i.invoice_date) {
              i.invoice_date = moment(i.invoice_date).tz('Asia/Singapore').format('DD/MM/YYYY')
            }
          }
          if (result.data.length > 0) {
            this.setState(
              {
                csvReport: result.data,
                isLoading: false,
              },
              () => {
                setTimeout(() => {
                  this.csvLinkEl2.current.link.click()
                })
              },
            )
          } else {
            this.CsvNotFound()
          }
        }
      })
      .catch(error => {
        //alert(error);
        this.setState({ isLoading: false })
      })
  }

  handleSubmit = e => {
    e.preventDefault()
    this.setState({ isLoading: true })
    if (this.state.status === 'Daily') {
      this.dailyOrder()
    } else {
      this.searchOrder()
    }
  }

  render() {
    let data = {
      columns: this.state.status === 'Daily' ? tbcolumn : this.props.tbcolumn,
      rows: this.state.filterList,
    }
    return (
      <>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        {this.state.isLoading && (
          <div
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              marginTop: -16,
              marginLeft: -16,
              zIndex: 1,
            }}>
            <Spinner animation="border" variant="primary" />
          </div>
        )}
        <Row>
          <Col sm={3}>
            <Input className="ps-input-small" type="select" name="status" value={this.state.status} onChange={this.changeHandler}>
              <option value="Daily">Daily</option>
              <option value="Search">Search</option>
            </Input>
          </Col>
          {this.state.status === 'Daily' && (
            // <Col sm={3}>
            //   <Input
            //     className="ps-input-small ps-input-fit"
            //     type="date"
            //     name="date"
            //     value={this.state.date}
            //     onChange={this.changeHandler}
            //   />
            // </Col>
            <Col md={4}>
              <Row>
                <Label className="text-center" sm={3}>
                  Status
                </Label>
                <Col sm={5}>
                  <Input className="ps-input-small" type="select" name="filterKey" value={this.state.filterKey} onChange={this.filterHandler}>
                    <option value="Default">Default</option>
                    {this.state.stateList.map(i => {
                      return (
                        <option key={i.id} value={i.name}>
                          {i.name}
                        </option>
                      )
                    })}
                  </Input>
                </Col>
                <Col sm={4}>
                  <Button
                    className="theme-button theme-button-dark"
                    onClick={() => {
                      this.filterData(this.state.showInvoice)
                    }}>
                    Filter
                  </Button>
                </Col>
              </Row>
            </Col>
          )}
          <Col md={3}>
            <FormGroup check>
              <Label check>
                <Input type="checkbox" name="showInvoice" checked={this.state.showInvoice} onChange={this.checkHandler} />
                Show Invoice Only
              </Label>
            </FormGroup>
          </Col>
        </Row>
        {this.state.status === 'Daily' && (
          <Form onSubmit={this.handleSubmit}>
            <Row>
              <Col md={3}>
                <FormGroup>
                  <Label>Start Date</Label>
                  <Input className="ps-input-small" type="date" name="fm_date" value={this.state.fm_date} onChange={this.searchHandler} disabled={this.state.isLoading} required />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label>End Date</Label>
                  <Input className="ps-input-small" type="date" name="to_date" value={this.state.to_date} onChange={this.searchHandler} disabled={this.state.isLoading} required />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label>Search Type</Label>
                  <Input className="ps-input-small" type="select" name="search_type" value={this.state.search_type} onChange={this.searchHandler} disabled={this.state.isLoading} required>
                    <option value="Order">Order</option>
                    <option value="Fulfilment">Fulfilment</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col
                md={3}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: this.comp.CompanyID === 'XhUFtI89G6HdfBALkPaW' ? 'space-around' : '',
                  paddingTop: '12px',
                }}>
                <Button type="submit" className="ps-input-small" disabled={this.state.isLoading}>
                  Search
                </Button>
                {this.comp.CompanyID === 'XhUFtI89G6HdfBALkPaW' && (
                  <>
                    {/* <CSVLink
                      data={this.state.csvList}
                      headers={headers}
                      filename={
                        'invoice_' +
                        moment(this.state.fm_date, 'YYYY-MM-DD').format(
                          'YYMMDD',
                        ) +
                        '_' +
                        moment(this.state.to_date, 'YYYY-MM-DD').format(
                          'YYMMDD',
                        ) +
                        '.csv'
                      }
                      // onClick={() => {
                      //   if (this.state.csvList.length < 1) {
                      //     this.CsvNotFound();
                      //     return false;
                      //   }
                      // }}
                    >
                      <Button
                        type="button"
                        className="ps-input-small theme-button-primary"
                        disabled={this.state.isLoading}
                      >
                        Export Invoice
                      </Button>
                    </CSVLink> */}
                    {/* <input
                      type="button"
                      value="Export to CSV (Async)"
                      onClick={this.CsvOrder}
                    /> */}
                    {/* <Button type="button" className="ps-input-small theme-button-primary" disabled={this.state.isLoading} onClick={this.CsvOrder}>
                      Export Invoice
                    </Button>
                    <CSVLink headers={headers} filename={'invoice_' + moment(this.state.fm_date, 'YYYY-MM-DD').format('YYMMDD') + '_' + moment(this.state.to_date, 'YYYY-MM-DD').format('YYMMDD') + '.csv'} data={this.state.csvList} ref={this.csvLinkEl} /> */}

                    {/* <CSVLink
                      data={this.state.csvReport}
                      headers={report_headers}
                      filename={
                        'Service_Report_' +
                        moment(this.state.fm_date, 'YYYY-MM-DD').format(
                          'YYMMDD',
                        ) +
                        '_' +
                        moment(this.state.to_date, 'YYYY-MM-DD').format(
                          'YYMMDD',
                        ) +
                        '.csv'
                      }
                      onClick={() => {
                        if (this.state.csvReport.length < 1) {
                          this.CsvNotFound();
                          return false;
                        }
                      }}
                    >
                      <Button
                        type="button"
                        className="ps-input-small theme-button-primary-light"
                        disabled={this.state.isLoading}
                      >
                        Export Service Report
                      </Button>
                    </CSVLink> */}
                    <Button type="button" className="ps-input-small theme-button-primary-light" disabled={this.state.isLoading} onClick={this.CsvReport}>
                      Export Service Report
                    </Button>
                    <CSVLink headers={report_headers} filename={'Service_Report_' + moment(this.state.fm_date, 'YYYY-MM-DD').format('YYMMDD') + '_' + moment(this.state.to_date, 'YYYY-MM-DD').format('YYMMDD') + '.csv'} data={this.state.csvReport} ref={this.csvLinkEl2} />
                  </>
                )}
              </Col>
            </Row>
          </Form>
        )}
        {this.state.status === 'Search' && (
          <Form onSubmit={this.handleSubmit}>
            <Row>
              <Col md={3}>
                <FormGroup>
                  <Label>Start Date</Label>
                  <Input className="ps-input-small" type="date" name="start_dt" value={this.state.start_dt} onChange={this.searchHandler} disabled={this.state.isLoading} required />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label>End Date</Label>
                  <Input className="ps-input-small" type="date" name="end_dt" value={this.state.end_dt} onChange={this.searchHandler} disabled={this.state.isLoading} required />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label>Search Text</Label>
                  <Input className="ps-input-small" type="text" name="order_id_str" value={this.state.order_id_str} onChange={this.searchHandler} disabled={this.state.isLoading} />
                </FormGroup>
              </Col>
              <Col
                md={3}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: this.comp.CompanyID === 'XhUFtI89G6HdfBALkPaW' ? 'space-around' : '',
                  paddingTop: '12px',
                }}>
                <Button type="submit" className="ps-input-small" disabled={this.state.isLoading}>
                  Search
                </Button>
                {this.comp.CompanyID === 'XhUFtI89G6HdfBALkPaW' && (
                  // <CSVLink
                  //   data={this.state.csvList}
                  //   headers={headers}
                  //   filename={
                  //     'invoice_' +
                  //     moment(this.state.fm_date, 'YYYY-MM-DD').format(
                  //       'YYMMDD',
                  //     ) +
                  //     '_' +
                  //     moment(this.state.to_date, 'YYYY-MM-DD').format(
                  //       'YYMMDD',
                  //     ) +
                  //     '.csv'
                  //   }
                  //   onClick={() => {
                  //     if (this.state.csvList.length < 1) {
                  //       this.CsvNotFound();
                  //       return false;
                  //     }
                  //   }}
                  // >
                  //   <Button
                  //     type="button"
                  //     className="ps-input-small theme-button-primary"
                  //     disabled={this.state.isLoading}
                  //   >
                  //     Export Invoice
                  //   </Button>
                  // </CSVLink>

                  <>
                    {/* <Button type="button" className="ps-input-small theme-button-primary" disabled={this.state.isLoading} onClick={this.CsvOrder}>
                      Export Invoice
                    </Button>
                    <CSVLink headers={headers} filename={'invoice_' + moment(this.state.fm_date, 'YYYY-MM-DD').format('YYMMDD') + '_' + moment(this.state.to_date, 'YYYY-MM-DD').format('YYMMDD') + '.csv'} data={this.state.csvList} ref={this.csvLinkEl} /> */}
                  </>
                )}
              </Col>
            </Row>
          </Form>
        )}
        <MDBDataTableV5 className="ps-order-table th-11" data={data} displayEntries={false} searchTop searchBottom={false} noRecordsFoundLabel="No data to show" fullPagination disableRetreatAfterSorting onSort={value => this.onSort(value)} responsive={true} />
        <Modal isOpen={this.state.invoiceModal} toggle={this.invoiceModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <Form onSubmit={this.invoice}>
            <ModalHeader toggle={this.invoiceModal()}>Invoice</ModalHeader>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label>Order ID</Label>
                    <Input type="text" name="edit_order_id" value={this.state.edit_order_id} readOnly />
                  </FormGroup>
                  <FormGroup>
                    <Label>Invoice Date</Label>
                    <Input type="date" name="edit_invoice_dt" value={this.state.edit_invoice_dt} onChange={this.inputHandler} required />
                  </FormGroup>
                  <FormGroup>
                    <Label>Invoice No</Label>
                    <Input type="text" name="edit_invoice_no" value={this.state.edit_invoice_no} onChange={this.inputHandler} required />
                  </FormGroup>
                  <FormGroup check>
                    <Label check>
                      <Input type="checkbox" name="edit_invoice_verify" onChange={this.checkHandler} checked={this.state.edit_invoice_verify} disabled={this.state.storeRole === 'Superuser' || this.state.storeRole === 'Financial' ? false : true} /> Verified
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button className="theme-button theme-button-primary" type="submit">
                Save
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
      </>
    )
  }
}

export default SearchOrder
